import React, { useEffect, useState } from "react";
import { notifyError } from "../../../utils/tostfy";
import { Link, useSearchParams } from "react-router-dom";
import { handleApiCall } from "../../../apis";
import { endpoint } from "../../../utils/endpoints";
import { formatInr } from "../../../utils/formatAmount";

const ViewRoute = () => {
  const [searchParams] = useSearchParams();
  const routeId = searchParams.get("route_id") || "";
  const [loading, setLoading] = useState(true);
  const [routeData, setRouteData] = useState(null);

  const normalizeRoute = (r) => ({
    routeRefId:
      r?.route_ref_id != null && String(r.route_ref_id).trim() !== ""
        ? String(r.route_ref_id)
        : "-",
    company: r?.company_id?.name || r?.company?.name || "-",
    companyLocation:
      r?.company_location_id?.name || r?.company_location?.name || "-",
    miplLocation: r?.mipl_location_id?.name || r?.mipl_location?.name || "-",
    idealAverage: r?.ideal_average ?? "-",
    status: r?.status === 1 ? "Active" : r?.status === 0 ? "Inactive" : "-",
    singleDriverAmount: formatInr(r?.single_driver_trip_amount),
    dualDriverAmount: formatInr(r?.dual_driver_trip_amount),
  });

  useEffect(() => {
    const fetchRouteDetail = async () => {
      if (!routeId) {
        setLoading(false);
        notifyError("Route ID is missing");
        return;
      }
      setLoading(true);
      try {
        const response = await handleApiCall(
          "get",
          `${endpoint.viewRoute}?route_id=${encodeURIComponent(routeId)}`,
          {}
        );
        if (response?.data?.code === 200) {
          const d = response?.data?.data;
          const raw =
            d?.route_data ||
            d?.route ||
            (Array.isArray(d) ? d[0] : null) ||
            d;
          setRouteData(normalizeRoute(raw));
        } else {
          const errMsg =
            response?.response?.data?.errorMessage ||
            response?.response?.data?.message ||
            response?.data?.message ||
            "Failed to load route details";
          notifyError(errMsg);
        }
      } catch {
        notifyError("Failed to load route details");
      } finally {
        setLoading(false);
      }
    };

    fetchRouteDetail();
  }, [routeId]);

  const Card = ({ children }) => (
      <div className="bg-white rounded-2xl border md:p-6 p-3 mb-4 font-UbuntuMedium max-[767px]:text-sm">
          {children}
      </div>
  );

  const Row = ({ label, value }) => (
      <div className="flex justify-between py-1">
          <span className="text-gray-400">{label}</span>
          <span className="text-gray-800">{value}</span>
      </div>
  );
  return (
    <div className="md:mt-7 mt-3">
      <Link to="/route-master" className="btn btn-primary mb-3">Back</Link>

      <div className="md:rounded md:p-6 bg-white md:shadow-sm">
        <div className="font-UbuntuMedium text-lg md:text-xl mb-3">Route Details</div>
        {loading ? (
          <Card>
            <div className="text-center text-gray-500 py-6">Loading...</div>
          </Card>
        ) : (
        <Card>
          <div className="grid grid-cols-1 md:grid-cols-2 md:gap-12">
              <div className="border-r md:pr-12">
                  <Row label="Route ID" value={routeData?.routeRefId || "-"} />
                  <Row label="Company" value={routeData?.company || "-"} />
                  <Row label="Company Location" value={routeData?.companyLocation || "-"} />
                  <Row label="MIPL Location" value={routeData?.miplLocation || "-"} />
              </div>
              <div>
                  <Row label="Ideal Average" value={routeData?.idealAverage ?? "-"} />
                  <Row label="Status" value={routeData?.status || "-"} />
                  <Row label="Single Driver Amount" value={routeData?.singleDriverAmount ?? "-"} />
                  <Row label="Dual Driver Amount" value={routeData?.dualDriverAmount ?? "-"} />
              </div>
          </div>
        </Card>
        )}
      </div>
    </div>
  );
};

export default ViewRoute;
